import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../macroscopia.action';
import MacroscopiaAPI from '../../macroscopia.api';
import ProtocoloMacroscopiaPage from './protocolo.page';

class ProtocoloMacroscopiaContainer extends Component {
    constructor() {
        super();
        this.state = {
            blocoselecionado: undefined
        }
    }

    render() {
        return <ProtocoloMacroscopiaPage
            blocos={this.props.blocos} protocolo={this.props.protocolo} laminas={this.props.laminas}
            onBlocoChange={this.onBlocoChange.bind(this)} onProtocoloChange={this.onProtocoloChange.bind(this)} />
    }

    componentDidMount() {
        MacroscopiaAPI.getProtocolo().then((protocolos) => {
            this.props.actions.preencherProtocolo(protocolos)
        })
    }

    onBlocoChange(value) {
        this.setState({
            blocoselecionado: value
        })
    }

    onProtocoloChange(value) {        
        if (this.state.blocoselecionado === undefined)
            return;

        let laminas = [...this.props.laminas];

        laminas.push({
            id: 9,
            bloco: this.state.blocoselecionado,
            protocolo: value
        });

        this.props.actions.preenhcerLaminaProtocolo(laminas);
    }
}

const mapStatesToProps = (state) => {
    return {
        blocos: state.macroscopia.blocosExistentes,
        protocolo: state.macroscopia.protocolo,
        laminas: state.macroscopia.laminas
    }
}

const mapsDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStatesToProps, mapsDispatchToProps)(ProtocoloMacroscopiaContainer);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/protocolo/protocolo.container.js